export default {
  valuesQuery: {
    url: "GetCustomOptionFieldValues.json?v=1.21&jsconfig=edv:0,inv",
    autoLoad: false,
    append: true,
    pageSize: 24,
    groupSize: 4,
    orderBy: "ValueText",
    views: {
      cards: "th",
      list: "th-list",
      //'map': 'map'
    },
    view: "cards",
  },
  disclaimerText: "",
  hidePrevConfig: false,
  useFieldSlider: true,
  useValueSlider: true,
  defaultFirstTabOpen: true,
  disableValuePrompt: false,
  resetValuesAfterSelection: true,
  hideAsShown: false,
  optionalLabel: " (optional*)",
  useTextArea: (f) => [f.tab, f.description].indexOf("Additional Notes") >= 0,
  isFieldHidden: (f, $ctrl) => false,
};
